import React from 'react';
import Highlights from '../components/Highlights';

const HighlightsPage = () => {
  return (
    <>
      <Highlights />
    </>
  );
};

export default HighlightsPage;
